import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-channels',
    templateUrl: './channels.component.html',
    styleUrls: ['./channels.component.scss']
})
export class DashboardChannelsComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
